<template>
  <div class="q-accordion-item q-w-100">
    <div class="q-accordion-header q-position-relative q-w-100" :id="headerId">
      <button class="q-btn q-btn-sm q-accordion-button q-rotatable q-w-100"
              :class="{'q-collapsed': isCollapsed,
               'q-rotated': !isCollapsed
              }"
              type="button"
              @click="toggleAccordion"
              :aria-expanded="!isCollapsed.toString()"
              :aria-controls="sectionId">
        {{ queriesHeader }}
      </button>
    </div>
    <div :id="sectionId"
         class="q-accordion-collapse"
         :class="{'q-collapse': isCollapsed, 'q-show': !isCollapsed}"
         :aria-labelledby="headerId">
      <div class="q-accordion-body q-p-1">
        <QueriesList :queries="queries" :can-remove="canRemove"/>
        <ClearQueriesButton v-if="canRemove"/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {defineProps, ref} from "vue";
import QueriesList from './QueriesList.vue';
import ClearQueriesButton from "@/components/AutocompletePopup/OnFocus/Queries/ClearQueriesButton.vue";

const props = defineProps(['queriesHeader', 'queries', 'canRemove']);
const sectionId = ref(normalizeText(props.queriesHeader));
const headerId = ref(`header_${sectionId.value}`);
const isCollapsed = ref(true);

function normalizeText(text: string): string {
  return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '_')
      .replace(/[^a-z0-9_]/g, '');
}

function toggleAccordion() {
  isCollapsed.value = !isCollapsed.value;
}
</script>

<style scoped>
.q-accordion-item {
  background-color: #fff;
  border: 0px solid rgba(0, 0, 0, .125);
}

.q-accordion-button {
  color: rgba(33, 37, 41, 0.75);
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  box-shadow: unset;
}

.q-accordion-button.q-rotatable::after {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
  content: "";
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-size: 1.25rem;
}

.q-rotatable::after {
  transform: rotate(0deg);
  transition: transform .2s ease-in-out;
}

.q-rotated::after {
  transform: rotate(180deg);
}

</style>